import type { Task } from '../services/taskService';

const withoutRepeatedPagePrefix = (title: string): string => {
  const separator = title.indexOf(' / ');

  if (separator < 0) return title;
  const page = title.slice(0, separator).trim();
  const section = title.slice(separator + 3).trim();

  return section.toLowerCase().startsWith(`${page.toLowerCase()} `)
    ? `${page} / ${section.slice(page.length).trim()}` : title;
};

/** Presentation labels only; stored task titles and execution scope stay unchanged. */
export const taskDisplayTitle = (title: string): string => {
  const known: Record<string, string> = {
    'Create requirements': 'Generate system requirement document',
    'System Requirement Document': 'Generate system requirement document',
    'Generate System Requirement Document': 'Generate system requirement document',
    'Generate system requirement document': 'Generate system requirement document',
    'Create personas and user flows': 'Generate personas & user flows',
    'Personas & user flows': 'Generate personas & user flows',
    'Generate personas & user flows': 'Generate personas & user flows',
    'Create architecture': 'Architecture',
    'Create workspace task plan': 'Workspace task plan',
  };

  if (known[title]) return known[title];
  const concise = title.replace(/^Backend capability:\s*/i, '')
    .replace(/^Generate (?:shared )?/i, '')
    .replace(/\s*\((?:durable,?\s*)?no auth(?:entication)?\)$/i, '')
    .replace(/\s*\(no redesign\)$/i, '')
    .replace(/^Persist data across sessions for books and reading progress$/i, 'Save books and reading progress')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\bNavbar\b/g, 'Navigation');

  return withoutRepeatedPagePrefix(concise || title);
};

/** Legacy sprint names may be formed from requirement keys rather than a user goal. */
export const sprintDisplayTitle = (name: string | null | undefined, number: number): string => (
  !name?.trim() || /\b(?:req-[a-f0-9]{8,}|planning-boundary:|obligation(?:-input)?:)/i.test(name)
    ? `Sprint ${number}` : name
);

export const taskCountLabel = (tasks: Task[], filtered: Task[], view: string): string => {
  const shown = ['sprint', 'phases', 'epic'].includes(view)
    ? tasks.filter((task) => task.task_type !== 'planning') : filtered;
  const planning = shown.filter((task) => task.task_type === 'planning').length;
  const scope = shown.length > 0 && planning === shown.length ? 'planning '
    : planning === 0 ? 'workspace ' : '';
  const total = shown.length !== tasks.length ? ` / ${tasks.length} total` : '';

  return `${shown.length} ${scope}${shown.length === 1 ? 'task' : 'tasks'}${total}`;
};
